"use strict";

module.exports = function (value) {
    if (value && value.toString) {
        return value.toString();
    }
    return String(value);
};



/** WEBPACK FOOTER **
 ** ./~/sinon/lib/sinon/util/core/value-to-string.js
 **/